import { type Common } from './common.js';
import { type Response } from './models/ipstack.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async getIpLocation(): Promise<Response> {
    const url = this.common.constructPath('/patient-previsit/ip/location');
    return await this.common.getJSON(url);
  }
}
